import isArray from 'lodash/isArray';
import { getFirstFocusableNode } from '@utils/dom.utils';

export function focusableLastRef (refs) {
    const lastRef = isArray(refs) ? refs[refs.length - 1] : refs;
    const node = lastRef.$el || lastRef;

    return getFirstFocusableNode(node);
}
